export default {
  fieldTypeText: '0',//单行文本类型
  fieldTypeTextarea: '1',//多行文本框类型
  fieldTypeBoolean: '2',//布尔类型
  fieldTypeSelect: '3',//单选类型
  fieldTypeCheck: '4',//复选类型
  fieldTypeInt: '5',//整数类型
  fieldTypeDouble: '6',//实数类型
  fieldTypeRate: '7',//百分比类型
  fieldTypePhone: '8',//电话类型
  fieldTypeAutonum: '9',//自动编号类型
  fieldTypeDate: '10',//日期类型 (年月日)
  fieldTypeDatetime: '11',//日期时间类型(年月日时分秒)
  fieldTypeMail: '12',//邮箱类型
  fieldTypeWebsite: '13',//网页地址（链接）类型
  fieldTypeArea: '14',//省市区类型
  fieldTypePhoto: '15',//图片类型
  fieldTypeEnclosure: '16',//附件类型
  fieldTypeObject: '17',//关联对象
  fieldTypeObjectParam: '18',//引用字段
  fieldTypeMainChild: '19',//主子明细字段
  fieldTypeRule: '20',//计算规则
  fieldTypePosition: '21',//定位类型
}
var fields = {
  fieldTypeText: {
    type: '0',//单行文本类型
    val: '',
  },
  fieldTypeTextarea: {
    type: '1',//多行文本框类型
    val: ''
  },
  fieldTypeBoolean: {
    type: '2',//布尔类型
    val: ''
  },
  fieldTypeSelect: {
    type: '3',//单选类型
    val: ''
  },
  fieldTypeCheck: {
    type: '4',//复选类型
    val: ''
  },
  fieldTypeInt: {
    type: '5',//整数类型
    val: ''
  },
  fieldTypeDouble: {
    type: '6',//实数类型
    val: ''
  },
  fieldTypeRate: {
    type: '7',//百分比类型
    val: ''
  },
  fieldTypePhone: {
    type: '8',//电话类型
    val: '',
    re: [
      new RegExp(/\d{10,12}$/),//固话
      new RegExp(/^1[3456789]\d{9}$/),//手机号
      new RegExp(/^((\d{10,12})|(1[3456789]\d{9}))$/)//固话或者手机号
    ]
  },
  fieldTypeAutonum: {
    type: '9',//自动编号类型
    val: ''
  },
  fieldTypeDate: {
    type: '10',//日期类型 (年月日)
    val: ''
  },
  fieldTypeDatetime: {
    type: '11',//日期时间类型(年月日时分秒)
    val: ''
  },
  fieldTypeMail: {
    type: '12',//邮箱类型
    val: '',
    re: new RegExp('^([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\\_|\\.]?)*[a-zA-Z0-9]+\\.[a-zA-Z]{2,3}$', '')
  },
  fieldTypeWebsite: {
    type: '13',//网页地址（链接）类型
    val: ''
  },
  fieldTypeArea: {
    type: '14',//省市区类型
    val: '',
    // re: [
    //   new RegExp(/^([^/]){1,}/) // 不能只填详细地址，而不选省市区
    // ]
  },
  fieldTypePhoto: {
    type: '15',//图片类型
    val: ''
  },
  fieldTypeEnclosure: {
    type: '16',//附件类型
    val: ''
  },
  fieldTypeObject: {
    type: '17',//关联对象
    val: ''
  },
  fieldTypeObjectParam: {
    type: '18',//引用字段
    val: ''
  },
  fieldTypeMainChild: {
    type: '19',//主子明细字段
    val: ''
  },
  fieldTypeRule: {
    type: '20',//计算规则
    val: ''
  },
  fieldTypePosition: {
    type: '21',//计算规则
    val: ''
  },
  fieldTypeTree: {
    type: '22',//树结构字段
    val: ''
  }
}
export function fieldInitValue(type,item){
 for(let i in fields){
   if(fields[i].type == type){
     if(type == '2'){//布尔默认勾选
       return item.selectedState
     }
     return fields[i].val
   }
 }
 return ''
}
export function fieldInitRe(field){
  for(let i in fields){
    if(fields[i].type == field.fieldType){
      // console.log(field.fieldType)
      if(fields[i].type == '8'){//电话号码类型特殊处理
        return fields[i].re[field.fieldPattern] || ''
      }
      return fields[i].re
    }
  }
  return ''
}
